<template>
  <div class="card-body form-gorup-last">
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <p class="control-label">Username</p>
          <p class="form-control-plaintext">{{ user.username }}</p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">First Name</p>
          <input v-model="stateFirstName" v-validate="'required'" name="first_name" data-vv-as="first name" type="text" class="form-control" />

          <help-block field="first_name"/>
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">Last Name</p>
          <input v-model="stateLastName" v-validate="'required'" name="last_name" data-vv-as="last name" type="text" class="form-control" />

          <help-block field="last_name"/>
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label">Phone</label>
          <input v-model="statePhone" v-validate="" name="phone" type="text" class="form-control" />
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">Agency</p>
          <p class="form-control-plaintext">{{ user.agency ? user.agency.name : '' }}</p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">Backup Email Address</p>
          <p class="form-control-plaintext">{{ user.email }}</p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-12 text-right">
        <div class="form-group">
          <ladda-button :click="handleSaveChanges" :validate="true" class="btn btn-success">Save Changes</ladda-button>
        </div><!-- /.form-group -->
      </div>
    </div><!-- /.row -->
  </div>
</template>

<script>
import { userComputed, userMethods } from 'vx/helpers'
import { stateMapper } from 'mixins/users'
import { pick } from 'lodash'
import { handleServerErrors } from 'utils'

export default {
  mixins: [stateMapper],

  computed: {
    ...userComputed
  },

  methods: {
    ...userMethods,

    async handleSaveChanges () {
      let payload = pick(this.user, [
        'first_name',
        'last_name',
        'phone'
      ])

      try {
        await this.updateAccount(payload)
        this.$noty.success('Account details updated.')
      } catch (error) {
        handleServerErrors(error, this.$validator)
      }
    }
  }
}
</script>
